<template>
  <v-layout wrap>
    <v-flex
      shrink
      class="none-growth confirm-wrap"
    >
      <v-layout fill-height>
        <a
          class="confirm-btn confirm-btn_left"
          :class="[{ 'confirm-btn_active': active === 1 }, { disabled: disabled }]"
          @click="chosen(1)"
        >{{ btnLeft }}</a>
        <a
          class="confirm-btn confirm-btn_right"
          :class="[{ 'confirm-btn_active': active === 2 }, { disabled: disabled }]"
          @click="chosen(2)"
        >{{ btnRight }}</a>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mt-1
    >
      <div class="v-messages theme--light error--text">
        <div class="v-messages__wrapper">
          <div
            v-for="(error, index) in errorMessages"
            :key="index"
            class="v-messages__message mt-2"
          >
            {{ error }}
          </div>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import livingConditionTypeResource from '@/mixins/livingConditionTypeResource';

export default {
    name: 'ConfirmButtons',
    mixins: [livingConditionTypeResource],
    inject: ['$validator'],
    props: {
        value: {},
        btnLeft: {
            default: function () {
                return this.$t('buttons.yes');
            }
        },
        btnRight: {
            default: function () {
                return this.$t('buttons.no');
            }
        },
        boolean: {
            default: false,
            type: Boolean
        },
        string: {
            default: false,
            type: Boolean
        },
        possessions: {
            default: false,
            type: Boolean
        },
        disabled: {
            default: false,
            type: Boolean
        },
        'error-messages': {
            default: () => {
                return [];
            }
        }
    },
    data () {
        return {
            active: null
        };
    },
    watch: {
        active (val) {
            if (val === null) {
                this.emit(val);
                return;
            }
            if (this.boolean) {
                val = val === 1;
            }
            if (this.string) {
                val = val === 1 ? 'yes' : 'no';
            }
            if (this.possessions) {
                val =
          val === 1
              ? this.livingConditionsTypeResource[0].id
              : this.livingConditionsTypeResource[1].id;
            }
            this.emit(val);
        }
    },
    created () {
        if (typeof this.value === 'boolean') {
            this.active = this.value ? 1 : 2;
        } else if (typeof this.value === 'string') {
            this.active = this.value === 'yes' ? 1 : 2;
        } else if (this.possessions) {
            if (this.value === this.livingConditionsTypeResource[0].id) {
                this.active = 1;
            }
            if (this.value === this.livingConditionsTypeResource[1].id) {
                this.active = 2;
            }
        } else {
            this.active = this.value;
        }
    },
    methods: {
        chosen (val) {
            if (!this.disabled) {
                if (this.$attrs['data-vv-name'] != null) {
                    this.$validator.flag(this.$attrs['data-vv-name'], {
                        changed: true,
                        invalid: false,
                        validated: false
                    });
                    this.$validator.errors.remove(this.$attrs['data-vv-name']);
                }
                this.active = this.active === val ? null : val;
            }
        },
        emit (val) {
            this.$emit('input', val);
            this.$validator.validate(this.$attrs['data-vv-name'], val);
        }
    }
};
</script>

<style scoped></style>
